import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Building2, Check, Ban, CalendarClock } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { fdate } from "@/lib/fmt";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const TONE = { active: "bg-emerald-50 text-emerald-700", pending: "bg-amber-50 text-amber-700", suspended: "bg-rose-50 text-rose-700" };
const LABEL = { active: "Aktif", pending: "Menunggu", suspended: "Nonaktif" };

export default function PlatformCompanies() {
  const [rows, setRows] = useState([]);
  const [dates, setDates] = useState({});
  const load = () => api.get("/platform/companies").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const patch = async (c, body, msg) => {
    try { await api.patch(`/platform/companies/${c.id}`, body); toast.success(msg); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="platform-page">
      <div className="mb-6">
        <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">Super Admin</p>
        <h1 className="font-heading text-3xl font-bold flex items-center gap-2"><Building2 className="h-7 w-7 text-blue-800" />Perusahaan Penyewa</h1>
        <p className="text-sm text-slate-500">Setujui pendaftaran PT, atur masa aktif langganan (pembayaran manual/transfer), atau nonaktifkan PT.</p>
      </div>
      <div className="card-premium overflow-x-auto bg-white">
        <table className="tbl w-full text-sm" data-testid="platform-table">
          <thead><tr><th>PT</th><th>Pemilik</th><th>Daftar</th><th>User</th><th>Penawaran</th><th>Status</th><th>Aktif s/d</th><th>Aksi</th></tr></thead>
          <tbody>
            {rows.map((c, i) => (
              <tr key={c.id} data-testid={`platform-row-${i}`}>
                <td className="font-medium">{c.name}{c.id === "default" && <span className="ml-2 rounded bg-blue-50 px-1.5 text-[10px] text-blue-800">Utama</span>}</td>
                <td className="text-xs">{c.owner_name || "-"}<br /><span className="text-slate-500">{c.owner_email}</span></td>
                <td className="text-xs">{fdate(c.created_at)}</td>
                <td className="font-num">{c.users}</td>
                <td className="font-num">{c.quotations}</td>
                <td><span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${TONE[c.status] || ""}`} data-testid={`platform-status-${i}`}>{LABEL[c.status] || c.status}</span>
                  {c.expired && <span className="ml-1 rounded-full bg-rose-600 px-2 py-0.5 text-[10px] font-semibold text-white" data-testid={`platform-expired-${i}`}>Habis</span>}</td>
                <td>
                  <div className="flex items-center gap-1">
                    <Input type="date" className="h-8 w-36 bg-white text-xs" value={dates[c.id] ?? c.active_until ?? ""} onChange={(e) => setDates({ ...dates, [c.id]: e.target.value })} data-testid={`platform-until-${i}`} />
                    <Button size="icon" variant="ghost" title="Simpan masa aktif" onClick={() => patch(c, { active_until: dates[c.id] ?? c.active_until ?? "" }, "Masa aktif disimpan")} data-testid={`platform-until-save-${i}`}><CalendarClock className="h-4 w-4 text-blue-700" /></Button>
                  </div>
                  <p className="text-[10px] text-slate-400">{c.active_until ? "" : "Kosong = tanpa batas"}</p>
                </td>
                <td className="whitespace-nowrap">
                  {c.status !== "active" && <Button size="sm" className="mr-1" onClick={() => patch(c, { status: "active" }, `${c.name} diaktifkan`)} data-testid={`platform-approve-${i}`}><Check className="h-4 w-4 mr-1" />Setujui / Aktifkan</Button>}
                  {c.status === "active" && c.id !== "default" && <Button size="sm" variant="outline" className="bg-white" onClick={() => window.confirm(`Nonaktifkan ${c.name}?`) && patch(c, { status: "suspended" }, `${c.name} dinonaktifkan`)} data-testid={`platform-suspend-${i}`}><Ban className="h-4 w-4 mr-1 text-rose-600" />Nonaktifkan</Button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
